import { useEffect, useState } from "react";
import { Box } from "@mui/material";

const ProfileAvatar = ({ type, disableTransform = false, width }) => {
  const gradientBorder = {
    background:
      "linear-gradient(110deg, rgba(43,120,250,1) 0%, rgba(185,35,245,1) 76%)",
    boxShadow: "0px 1px 5px #747474",
    borderRadius: "50%",
    transform: !disableTransform && "scale(0.5)",
    p: "15px 16px",
    width: width ? width : "13em",
    display: "flex",
  };
  const image = {
    backgroundColor: "#f2f4f8",
    borderRadius: "50%",
    width: !disableTransform
      ? width
        ? `calc(${width} - 2em)`
        : "11em"
      : "100%",
  };

  const [source, setSource] = useState("");

  useEffect(() => {
    if (type) {
      const typeNumber = Math.max(parseInt(type?.substring(4)), 12);
      setSource(`images/avatars/type${typeNumber || "12"}.svg`);
    }
  }, [type]);

  return (
    <Box sx={gradientBorder}>
      <Box sx={image} component="img" src={source} alt="User Avatar" />
    </Box>
  );
};

export default ProfileAvatar;
